import { render, staticRenderFns } from "./callDetails.vue?vue&type=template&id=a73a7436&"
import script from "./callDetails.vue?vue&type=script&lang=js&"
export * from "./callDetails.vue?vue&type=script&lang=js&"
import style0 from "./callDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports